/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { psychosControllerCreate } from '../fn/psychos/psychos-controller-create';
import { PsychosControllerCreate$Params } from '../fn/psychos/psychos-controller-create';
import { psychosControllerDelete } from '../fn/psychos/psychos-controller-delete';
import { PsychosControllerDelete$Params } from '../fn/psychos/psychos-controller-delete';
import { psychosControllerFilter } from '../fn/psychos/psychos-controller-filter';
import { PsychosControllerFilter$Params } from '../fn/psychos/psychos-controller-filter';
import { psychosControllerFindOne } from '../fn/psychos/psychos-controller-find-one';
import { PsychosControllerFindOne$Params } from '../fn/psychos/psychos-controller-find-one';
import { psychosControllerFindRandom } from '../fn/psychos/psychos-controller-find-random';
import { PsychosControllerFindRandom$Params } from '../fn/psychos/psychos-controller-find-random';
import { psychosControllerHandleEvents } from '../fn/psychos/psychos-controller-handle-events';
import { PsychosControllerHandleEvents$Params } from '../fn/psychos/psychos-controller-handle-events';
import { psychosControllerReactivate } from '../fn/psychos/psychos-controller-reactivate';
import { PsychosControllerReactivate$Params } from '../fn/psychos/psychos-controller-reactivate';
import { psychosControllerUpdate } from '../fn/psychos/psychos-controller-update';
import { PsychosControllerUpdate$Params } from '../fn/psychos/psychos-controller-update';
import { ResponsePsychoDto } from '../models/response-psycho-dto';

@Injectable({ providedIn: 'root' })
export class PsychosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `psychosControllerHandleEvents()` */
  static readonly PsychosControllerHandleEventsPath = '/thalea-psychos/psychos/cognito';

  /**
   * Handle SQS events for psycho creation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerHandleEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerHandleEvents$Response(params?: PsychosControllerHandleEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return psychosControllerHandleEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle SQS events for psycho creation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerHandleEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerHandleEvents(params?: PsychosControllerHandleEvents$Params, context?: HttpContext): Observable<void> {
    return this.psychosControllerHandleEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `psychosControllerCreate()` */
  static readonly PsychosControllerCreatePath = '/thalea-psychos/psychos';

  /**
   * Create a psycho.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerCreate$Response(params: PsychosControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
    return psychosControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a psycho.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerCreate(params: PsychosControllerCreate$Params, context?: HttpContext): Observable<ResponsePsychoDto> {
    return this.psychosControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePsychoDto>): ResponsePsychoDto => r.body)
    );
  }

  /** Path part for operation `psychosControllerFindRandom()` */
  static readonly PsychosControllerFindRandomPath = '/thalea-psychos/psychos/random/{tenant}/{patientId}';

  /**
   * Get a random psycho by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerFindRandom()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerFindRandom$Response(params: PsychosControllerFindRandom$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
    return psychosControllerFindRandom(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a random psycho by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerFindRandom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerFindRandom(params: PsychosControllerFindRandom$Params, context?: HttpContext): Observable<ResponsePsychoDto> {
    return this.psychosControllerFindRandom$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePsychoDto>): ResponsePsychoDto => r.body)
    );
  }

  /** Path part for operation `psychosControllerFindOne()` */
  static readonly PsychosControllerFindOnePath = '/thalea-psychos/psychos/{tenant}/{id}';

  /**
   * Find a psycho by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerFindOne$Response(params: PsychosControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
    return psychosControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find a psycho by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerFindOne(params: PsychosControllerFindOne$Params, context?: HttpContext): Observable<ResponsePsychoDto> {
    return this.psychosControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePsychoDto>): ResponsePsychoDto => r.body)
    );
  }

  /** Path part for operation `psychosControllerUpdate()` */
  static readonly PsychosControllerUpdatePath = '/thalea-psychos/psychos/{tenant}/{id}';

  /**
   * Update a psycho.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerUpdate$Response(params: PsychosControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
    return psychosControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a psycho.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerUpdate(params: PsychosControllerUpdate$Params, context?: HttpContext): Observable<ResponsePsychoDto> {
    return this.psychosControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponsePsychoDto>): ResponsePsychoDto => r.body)
    );
  }

  /** Path part for operation `psychosControllerDelete()` */
  static readonly PsychosControllerDeletePath = '/thalea-psychos/psychos/{tenant}/{id}';

  /**
   * Delete a psycho.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerDelete$Response(params: PsychosControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return psychosControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a psycho.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerDelete(params: PsychosControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.psychosControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `psychosControllerReactivate()` */
  static readonly PsychosControllerReactivatePath = '/thalea-psychos/psychos/{tenant}/{id}/reactivate';

  /**
   * Reactivate a psycho.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerReactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerReactivate$Response(params: PsychosControllerReactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return psychosControllerReactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a psycho.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerReactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  psychosControllerReactivate(params: PsychosControllerReactivate$Params, context?: HttpContext): Observable<void> {
    return this.psychosControllerReactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `psychosControllerFilter()` */
  static readonly PsychosControllerFilterPath = '/thalea-psychos/psychos/filter';

  /**
   * Filter psychos based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `psychosControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerFilter$Response(params: PsychosControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePsychoDto>>> {
    return psychosControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter psychos based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `psychosControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  psychosControllerFilter(params: PsychosControllerFilter$Params, context?: HttpContext): Observable<Array<ResponsePsychoDto>> {
    return this.psychosControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponsePsychoDto>>): Array<ResponsePsychoDto> => r.body)
    );
  }

}
